/**
 * Temporary FK-RULE-007 policy. Keep the unresolved interpretation in this
 * single function so an owner decision changes one validation boundary.
 */
export const LAND_STAGE_MAX_CONTROL_POLICY = "nondecreasing" as const;

export interface LandStageControlValue {
  readonly maximumControl: number;
}

export interface LandStageControlDecrease {
  readonly previousIndex: number;
  readonly currentIndex: number;
}

export function findLandStageControlDecrease(
  stages: readonly LandStageControlValue[],
): LandStageControlDecrease | null {
  for (let index = 1; index < stages.length; index += 1) {
    const previous = stages[index - 1];
    const current = stages[index];

    if (previous !== undefined && current !== undefined) {
      if (current.maximumControl < previous.maximumControl) {
        return { previousIndex: index - 1, currentIndex: index };
      }
    }
  }

  return null;
}

export function validateLandStageControlMonotonicity(
  stages: readonly LandStageControlValue[],
): boolean {
  return findLandStageControlDecrease(stages) === null;
}
